import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import app from './reducers/app';
import auth from './reducers/auth';
import items from './reducers/items';
import collections from './reducers/collections';
import orders from './reducers/orders';
import delivery from './reducers/delivery';
import packing from './reducers/packing';
import settings from './reducers/settings';
import modal from './reducers/modal';
import pages from './reducers/pages';
import supplies from './reducers/supplies';
import imports from './reducers/imports';
import summary from './reducers/summary';
import tickets from './reducers/tickets';
import finances from './reducers/finances';
import admin from './reducers/admin';
import documents from './reducers/documents';

const appReducer = combineReducers({
  app,
  auth,
  items,
  collections,
  orders,
  delivery,
  packing,
  settings,
  modal,
  pages,
  supplies,
  imports,
  summary,
  tickets,
  finances,
  admin,
  documents,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export const createAppStore = () => createStore(rootReducer, applyMiddleware(thunk));
